import ClearableButton from 'components/buttons/ClearableButton';
import PopoverDropdownList from 'components/popovers/PopoverDropdownList';
import React from 'react';
import type { InvoiceStatusFilterKeys } from 'types/invoice';

const allStatus: Record<InvoiceStatusFilterKeys, string> = {
  all: 'All',
  local_draft: 'Local draft',
  draft: 'Draft',
  sent_to_customer: 'Sent to customer',
  paid: 'Paid',
  void: 'Void',
};

interface Props {
  status: InvoiceStatusFilterKeys;
  setQuery: (action: InvoiceStatusFilterKeys) => void;
}

const InvoiceStatusDropdown: React.FC<Props> = ({ status, setQuery }) => {
  const handleClear = () => {
    setQuery('all');
  };

  const handleOnChange = ({ action }: { action: InvoiceStatusFilterKeys }) => {
    setQuery(action);
  };

  const selectedStatusText = allStatus[status];
  const showClearButton = status !== 'all';

  const statuses = Object.keys(allStatus) as Array<keyof typeof allStatus>;

  return (
    <PopoverDropdownList
      options={statuses.map(current => ({
        action: current,
        name: allStatus[current],
        active: current === status,
      }))}
      onClick={handleOnChange}
      target={
        <ClearableButton
          data-testid="invoice-status-dropdown"
          selected={showClearButton}
          priority="medium"
          onClear={showClearButton ? handleClear : undefined}
          isActive={null}
          clearTooltip="Clear the status filter"
        >
          <span>{selectedStatusText}</span>
        </ClearableButton>
      }
    />
  );
};

export default InvoiceStatusDropdown;
